import { atoms } from '@fiverr-private/theme';
import { responsiveDisplay } from './util';

export const goBackClassName = atoms({
    display: responsiveDisplay('block', false),
});
